import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';

const TooltipBlindMode = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent
        className='w-54 mr-2'
        sideOffset={8}
        side='top'
        variant='zinc'
      >
        <div className='w-full m-2'>
          <p className='text-sm'>{t('tooltip.blindMode.help')}</p>
        </div>
      </TooltipContent>
    </Tooltip>
  );
};
export default TooltipBlindMode;
